import { render, staticRenderFns } from "./DetailsTender.vue?vue&type=template&id=0da3ff3c&"
import script from "./DetailsTender.vue?vue&type=script&lang=js&"
export * from "./DetailsTender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports